/**
 * Ryan O'Dowd
 * 2023-12-30
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Searchbar as PaperSearchbar,
} from 'react-native-paper';
import React from 'react';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const Searchbar = React.forwardRef((props: SearchbarProps & React.ComponentProps<typeof PaperSearchbar>, __ref) => { // @TODO: ref is required to avoid " forwardRef render functions accept exactly two parameters: props and ref. Did you forget to use the ref parameter?"...should the ref be used somewhere here?
  const styles = hooks.useStyles(getStyles);

  const textColor = (!props.whiteVariant || styles.isDarkMode) ? styles.colors.white : styles.colors.primaryExtraDark;

  return (
    <View style={[styles.searchBarWrapper, props.containerStyles]}>
      <PaperSearchbar
        theme={{
          colors: {
            text: textColor,
            onSurfaceVariant: textColor,
            onSurface: textColor,
          },
          roundness: 0,
        }}
        autoFocus={true}
        iconColor={textColor}
        selectionColor={styles.colors.accent}
        autoCapitalize='none'
        keyboardType='ascii-capable'
        {...props}
        style={[styles.searchBar, props.whiteVariant && styles.searchBarWhite, props.style]}
      />
    </View>
  );
});

class SearchbarProps {
  containerStyles?: any;
  whiteVariant?: boolean;
};

Searchbar.displayName = 'Searchbar';
export default Searchbar;
